// extracted by mini-css-extract-plugin
export default {"cancelButton":"cancel_cancelButton__6fgvL"};